import React from 'react';
import classes from './classes.module.scss';

function Toast({
  toastText,
  show = false,
  bottomPlacement
}) {
  return (
    <div
      className={ show ? classes.toastContainer : classes.toastContainerHiden }
      style={ { '--bottom': bottomPlacement || '60px' } }
    >
      <div className={ classes.toast }>
        <div className={ classes.toastMessage }>
          {toastText}
        </div>
      </div>
    </div>
  );
}

export default Toast;
